export default {
  blank: () => import("/home/nodejs/kare-backoffice-v2/source/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/home/nodejs/kare-backoffice-v2/source/layouts/default.vue").then(m => m.default || m),
  navigation: () => import("/home/nodejs/kare-backoffice-v2/source/layouts/navigation.ts").then(m => m.default || m)
}